<div class="p-grid">
    <p-card class="p-col-8">
      <p-table [value]="template1BarData" [scrollable]="true" scrollHeight="160px" [rows]="10"
      [paginator]="true">
        <ng-template pTemplate="header">
            <tr>
                <th>Code</th>
                <th>Name</th>
                <th>Category</th>
                <th>Quantity</th>
                <th>Name</th>
                <th>Category</th>
                <th>Quantity</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-product>
            <tr>
                <td>{{product.code}}</td>
                <td>{{product.name}}</td>
                <td>{{product.category}}</td>
                <td>{{product.quantity}}</td>
                <td>{{product.name}}</td>
                <td>{{product.category}}</td>
                <td>{{product.quantity}}</td>
            </tr>
        </ng-template>
      </p-table>
    </p-card>
    <p-card class="p-col-4">
      <p-chart type="doughnut" (onDataSelect)="selectDoughnutData($event)" [data]="template3Doughnut" [height]="250"></p-chart>
    </p-card>
  </div>
  <div class="p-grid">
    <p-card class="p-col-8">
      <p-table [value]="template1BarData" [scrollable]="true" scrollHeight="160px" [rows]="10"
      [paginator]="true">
        <ng-template pTemplate="header">
            <tr>
                <th>Code</th>
                <th>Name</th>
                <th>Category</th>
                <th>Quantity</th>
                <th>Name</th>
                <th>Category</th>
                <th>Quantity</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-product>
            <tr>
                <td>{{product.code}}</td>
                <td>{{product.name}}</td>
                <td>{{product.category}}</td>
                <td>{{product.quantity}}</td>
                <td>{{product.name}}</td>
                <td>{{product.category}}</td>
                <td>{{product.quantity}}</td>
            </tr>
        </ng-template>
      </p-table>
    </p-card>
    <p-card class="p-col-4">
      <p-chart type="polarArea" [data]="template3Polar" [height]="250"></p-chart>
    </p-card>
  </div>
  <div class="p-grid">
    <p-card class="p-col-8">
      <p-table [value]="template1BarData" [scrollable]="true" scrollHeight="160px" [rows]="10"
      [paginator]="true">
        <ng-template pTemplate="header">
            <tr>
                <th>Code</th>
                <th>Name</th>
                <th>Category</th>
                <th>Quantity</th>
                <th>Name</th>
                <th>Category</th>
                <th>Quantity</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-product>
            <tr>
                <td>{{product.code}}</td>
                <td>{{product.name}}</td>
                <td>{{product.category}}</td>
                <td>{{product.quantity}}</td>
                <td>{{product.name}}</td>
                <td>{{product.category}}</td>
                <td>{{product.quantity}}</td>
            </tr>
        </ng-template>
      </p-table>
    </p-card>
    <p-card class="p-col-4">
      <p-chart type="radar" [data]="template3Radar" [height]="250"></p-chart>
    </p-card>
  </div>


  <p-dialog header="Doughnut Details" [(visible)]="displayDoughnutDetail" [modal]="true" [style]="{width: '60vw'}">
    <div class="card">
      <div class="p-grid">
        <div class="p-col-4 p-md-2">
            <p><strong>Lable: </strong></p>
        </div>
        <div class="p-col-8 p-md-4">
            <p>{{selectedDoughnutLabel}}</p>
        </div>
        <div class="p-col-4 p-md-2">
          <p><strong>Value: </strong></p>
        </div>
        <div class="p-col-8 p-md-4">
          <p>{{selectedDoughnutData}}</p>
        </div>
      </div>
    </div>
    <ng-template pTemplate="footer">
      <button pButton (click)="displayDoughnutDetail=false;" label="Cancel" class="p-button-secondary"></button>
      <button pButton label="Save"></button>
    </ng-template>
  </p-dialog>